export const FM_SHOW = 'FM_SHOW';
export const FM_HIDE = 'FM_HIDE';
export const FM_SET_INITIALIZED = 'FM_SET_INITIALIZED';
export const FM_SELECT_MENU = 'FM_SELECT_MENU';

export const FM_MENU_MAIN = 'FM_MENU_MAIN';
export const FM_MENU_OPEN = 'FM_MENU_OPEN';
export const FM_MENU_SAVE = 'FM_MENU_SAVE';
export const FM_MENU_NEW = 'FM_MENU_NEW';
export const FM_MENU_FORK = 'FM_MENU_FORK';
export const FM_MENU_SHARE = 'FM_MENU_SHARE';

export const FM_LOAD_CONCEPTS = 'FM_LOAD_CONCEPTS';
export const FM_LOAD_CONCEPTS_SUCCESS = 'FM_LOAD_CONCEPTS_SUCCESS';
export const FM_LOAD_CONCEPTS_FAILURE = 'FM_LOAD_CONCEPTS_FAILURE';

export const FM_NEW_CONCEPT = 'FM_NEW_CONCEPT';
export const FM_NEW_CONCEPT_SUCCESS = 'FM_NEW_CONCEPT_SUCCESS';
export const FM_NEW_CONCEPT_FAILURE = 'FM_NEW_CONCEPT_FAILURE';

export const FM_FORK_CONCEPT = 'FM_FORK_CONCEPT';
export const FM_FORK_CONCEPT_SUCCESS = 'FM_FORK_CONCEPT_SUCCESS';
export const FM_FORK_CONCEPT_FAILURE = 'FM_FORK_CONCEPT_FAILURE';

export const FM_TOGGLE_SHARED_CONCEPT = 'FM_TOGGLE_SHARED_CONCEPT';
export const FM_TOGGLE_SHARED_CONCEPT_SUCCESS =
  'FM_TOGGLE_SHARED_CONCEPT_SUCCESS';
export const FM_TOGGLE_SHARED_CONCEPT_FAILURE =
  'FM_TOGGLE_SHARED_CONCEPT_FAILURE';

export const FM_OPEN_REVISION = 'FM_OPEN_REVISION';
export const FM_OPEN_REVISION_SUCCESS = 'FM_OPEN_REVISION_SUCCESS';
export const FM_OPEN_REVISION_FAILURE = 'FM_OPEN_REVISION_FAILURE';

export const FM_SAVE_REVISION = 'FM_SAVE_REVISION';
export const FM_SAVE_REVISION_SUCCESS = 'FM_SAVE_REVISION_SUCCESS';
export const FM_SAVE_REVISION_FAILURE = 'FM_SAVE_REVISION_FAILURE';

export const FM_LOAD_BADWORDS = 'FM_LOAD_BADWORDS';
export const FM_LOAD_BADWORDS_SUCCESS = 'FM_LOAD_BADWORDS_SUCCESS';
export const FM_LOAD_BADWORDS_FAILURE = 'FM_LOAD_BADWORDS_FAILURE';

export const FM_SAVE_NOTES = 'FM_SAVE_NOTES';
export const FM_SAVE_NOTES_SUCCESS = 'FM_SAVE_NOTES_SUCCESS';
export const FM_SAVE_NOTES_FAILURE = 'FM_SAVE_NOTES_FAILURE';

export const FM_ENABLE_AUTOSAVE = 'FM_ENABLE_AUTOSAVE';
export const FM_DISABLE_AUTOSAVE = 'FM_DISABLE_AUTOSAVE';
